import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Skeleton from '@material-ui/lab/Skeleton';

import CurrentStatus from 'components/atoms/CurrentStatus';

import MbTableRow from './EnhancedTableRow';

const useStyles = makeStyles((theme) => ({
  fullscreenBody: { height: 600 },
  bodyListLoading: { height: 300 },
}));

/**
 * 테이블 body 컴포넌트
 * @param {Object} props
 */
const EnhancedTableBody = (props) => {
  const classes = useStyles();
  const {
    loading,
    headCells,
    list = [],
    totalList = null,
    tableState,
    useCheckBox,
    useTotal,
    pointer,
    page = 0,
    customized,
    expandTable,
    childColumnSet,
    handleAddSubList,
    dataDetailReqPromise,
    handleClick = (f) => f,
    useRowData,
    handleRowData,
    newSelected,
    rowsPerPage,
    useFetch,
    onMouseEnter,
    rowColor,
  } = props;

  const { total, list: listState } = tableState;

  const columnCnt = Array.isArray(headCells)
    ? headCells.length
    : headCells.size === undefined
    ? 0
    : headCells.size;

  useEffect(() => {
    onMouseEnter();
    // eslint-disable-next-line
  }, [loading]);

  /**
   * 리스트생성 함수
   * @returns {[]}
   */
  const makeRowItems = () => {
    const result = [];
    let newList = [];
    if (list !== null && list.length !== 0) {
      newList = useFetch
        ? list
        : list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
      if (page * rowsPerPage + rowsPerPage === -1) {
        newList = list;
      }
      // eslint-disable-next-line array-callback-return
      newList.map((row, index) => {
        result.push(
          <MbTableRow
            classes={classes}
            key={index}
            index={index}
            row={row}
            headCells={headCells}
            useCheckBox={useCheckBox}
            pointer={pointer}
            handleClick={handleClick}
            customized={customized}
            expandTable={expandTable}
            childColumnSet={childColumnSet}
            useFetch={useFetch}
            dataDetailReqPromise={dataDetailReqPromise}
            handleAddSubList={handleAddSubList}
            newSelected={newSelected}
            useRowData={useRowData}
            handleRowData={handleRowData}
            rowColor={rowColor}
          />
        );
      });
    }
    return result;
  };

  return (
    <>
      {useTotal && (
        <TableBody>
          {total === 'loading' || loading ? (
            <TableRow tabIndex={-1}>
              <TableCell colSpan={columnCnt + 1}>
                <Skeleton />
              </TableCell>
            </TableRow>
          ) : total === '' ? (
            <MbTableRow
              row={totalList}
              headCells={headCells}
              customized={customized}
              useTotal={true}
              dataDetailReqPromise={dataDetailReqPromise}
              handleAddSubList={handleAddSubList}
              expandTable={expandTable}
              useCheckBox={useCheckBox}
              useFetch={useFetch}
              newSelected={newSelected}
            />
          ) : (
            <TableRow tabIndex={-1}>
              <TableCell colSpan={columnCnt + 1}>
                <CurrentStatus type={total} useMessage={false} />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      )}
      <TableBody id="tableBodyListWrap">
        {listState === 'loading' || loading ? (
          <TableRow>
            <TableCell
              colSpan={columnCnt + 1}
              classes={{ root: classes.bodyListLoading }}
            >
              <>
                <Skeleton />
                <Skeleton width="60%" />
                <Skeleton />
                <Skeleton width="60%" />
                <Skeleton />
                <Skeleton width="60%" />
              </>
            </TableCell>
          </TableRow>
        ) : listState === '' ? (
          makeRowItems()
        ) : (
          <TableRow tabIndex={-1}>
            <TableCell
              classes={{ root: classes.bodyListLoading }}
              colSpan={columnCnt + 1}
            >
              <CurrentStatus type={listState} />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </>
  );
};

EnhancedTableBody.propTypes = {
  handleClick: PropTypes.func, //  디스플레이 구분
};

export default React.memo(withRouter(EnhancedTableBody));
